const INITIAL_STATE = {
  mySubscriptions : {}
};

export default INITIAL_STATE;